"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildSetters = buildSetters;
var _utils = require("../../utils");
var _actions = require("./actions");
function buildSetters(dispatch) {
  return {
    setCurrentStep: (0, _utils.wrapActionWithDispatch)(dispatch, _actions.setCurrentStep),
    setPackage: (0, _utils.wrapActionWithDispatch)(dispatch, _actions.setPackage),
    setCustomerType: (0, _utils.wrapActionWithDispatch)(dispatch, _actions.setCustomerType),
    setExistingCustomer: (0, _utils.wrapActionWithDispatch)(dispatch, _actions.setExistingCustomer),
    setCustomerName: (0, _utils.wrapActionWithDispatch)(dispatch, _actions.setCustomerName),
    setCustomerSurname: (0, _utils.wrapActionWithDispatch)(dispatch, _actions.setCustomerSurname),
    stepBack: (0, _utils.wrapActionWithDispatch)(dispatch, _actions.stepBack),
    setFrequency: (0, _utils.wrapActionWithDispatch)(dispatch, _actions.setFrequency),
    goToSummary: (0, _utils.wrapActionWithDispatch)(dispatch, _actions.goToSummary),
    setTermsAndConditions: (0, _utils.wrapActionWithDispatch)(dispatch, _actions.setTermsAndConditions)
  };
}
